<template>
  <div class="login-page">
    <a-layout>
      <a-layout class="login-panel">
        <a-layout-content class="login-left">
          <h3 class="title">致尚卷帘印画</h3>
          <p class="slogan">行业领跑者</p>
        </a-layout-content>
        <a-layout-sider width="450" theme="light" style="padding:50px 10px;">
          <a-alert v-show="message" type="error" :message="message" banner />
          <a-page-header title="账号登录" sub-title="ERP / MaxKey 登录"></a-page-header>
          <a-form-model
            ref="loginForm"
            :model="form"
            :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }"
            :rules="rules"
          >
            <a-form-model-item label="账号" prop="username">
              <a-input v-model="form.username" @keyup.enter.native="login"/>
            </a-form-model-item>
            <a-form-model-item label="密码" prop="password">
              <a-input type="password" v-model="form.password"
                @keyup.enter.native="login"
              />
            </a-form-model-item>
            <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
              <a-button type="primary" block @click="login" :loading="loading">登 录</a-button>
            </a-form-model-item>
          </a-form-model>
          <div class="login-divider">或</div>
          <a-button
            type="default"
            block
            class="sso-button"
            @click="ssoLogin"
            :loading="ssoLoading"
          >MaxKey 单点登录</a-button>
          <p class="sso-hint">统一身份认证：sso.cnblind.com</p>
          <p style="text-align:center"><a href="#">忘记密码?</a></p>
          <p style="text-align:center"><a href="#">回首页</a></p>
        </a-layout-sider>
      </a-layout>
      <a-layout-footer style="text-align: center">
        Ant Design ©2018 Created by Ant UED
      </a-layout-footer>
    </a-layout>

  </div>
</template>

<script>
import userModel from '@/api/user'
export default {
  components: {

  },
  data () {
    return {
      form: {
        username: '',
        password: ''
      },
      message: '',
      rules: {
        username: {required: true, message: '填写账号名', trigger: 'blur'},
        password: {required: true, message: '填写密码', trigger: 'blur'}
      },
      loading: false,
      ssoLoading: false
    }
  },
  created () {
    const messages = {
      sso_config: 'MaxKey 尚未完成服务端配置',
      sso_denied: 'MaxKey 登录已取消',
      sso_state: '登录状态已失效，请重新登录',
      sso_exchange: 'MaxKey 登录失败，请稍后重试',
      account: '本地账号不可用，请联系管理员'
    }
    this.message = messages[this.$route.query.error] || ''
  },
  methods: {
    ssoLogin () {
      this.ssoLoading = true
      // The authorization code and client secret are handled by Flask.
      window.location.href = '/admin/oauth/login'
    },
    login () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          const self = this
          self.loading = true
          userModel.login(this.form).then(_ => {
          // redirect to Home
            self.loading = false
            self.message = ''
            this.$router.push('/')
          }, err => {
            self.loading = false
            // show message
            if (err.status === 401) { self.message = '账号密码不正确' }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.login-panel{height:550px;width:850px;margin:40px auto;box-shadow: 0 0 15px 5px #ccc;background:#fff;}
.login-left{background: url(./juanlian.jpg) no-repeat #eee;background-size: cover;}
.login-left .title {margin:140px 0 0 72px;font-size:36px;color:#333}
.login-left .slogan{font-size:24px;font-style: italic;color:#606060;margin:8px 0 0 200px;}
.login-divider{text-align:center;color:#999;margin:12px 0;}
.sso-button{color:#1890ff;border-color:#1890ff;}
.sso-hint{text-align:center;color:#999;margin:8px 0 0;}
</style>



// WEBPACK FOOTER //
// src/pages/login/Login.vue